import OwnerPage from './OwnerPage';

export default OwnerPage;
